import { EVENTS_PROPERTIES } from './VehicleProvisionEventsProperties.js'

export default {
  props: {
    vehicleProvisionId: {
      type: Number,
      default: null
    },
    inputAdditionalParams: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      bussinessProcessConfiguration: {
        REQUEST_PROPERTIES: REQUEST_PROPERTIES,
        EVENTS_PROPERTIES: EVENTS_PROPERTIES,
        businessProcessKey: 'vehicleProvision',
        serviceSubPath: 'vehicleProvision'
      },

      loading: false,
      vehicleProvision: {
        bp: {},
        actions: [],
        request: {},
        requestInitial: {}, // ui
        requestForm: {},
        report: {},

        requestProperties: null
      },
      additionalParams: this.inputAdditionalParams
    }
  },
  computed: {
    record: {
      get: function () {
        return this.vehicleProvision
      },
      set: function (val) {
        this.vehicleProvision = val
      }
    },
    requestProperties: function () {
      return this.record.requestProperties
    }
  },
  methods: {
    onValidate: function (validFieldKeys) {
      if (this.$refs.request) {
        this.$refs.request.validate(validFieldKeys)
      }
    },
    processCustomAction: async function (reaction, target) {
      if (reaction.key === 'createRequest') {
        const vehicleProvisionId = -1
        const additionalParams = reaction.additionalParams || {}

        const module = await import('./VehicleProvisionDispatcher.vue')
        const VehicleProvisionDispatcher = module.default

        target.$d.dialog(target).show({
          maximized: true,
          persistent: true,
          headerHidden: true,
          contentComponent: VehicleProvisionDispatcher,
          contentProps: {
            vehicleProvisionId: vehicleProvisionId,
            inputAdditionalParams: additionalParams,
            dialog: true
          },
          componentHandlers: {}
        })
      }
    }
  }
}

const REQUEST_PROPERTIES = {
  createTime: () => ({ label: 'Дата/время создания заявки', type: 'datetime' }),
  serviceTimeRequired: () => ({
    label: 'Требуемое время подачи ТС',
    type: 'datetime'
    // dateTimeValidateFn
  }),
  serviceTimeRequiredInitial: () => ({
    label: 'Исходное требуемое время подачи ТС',
    type: 'datetime'
  }),
  serviceEndTimeRequired: () => ({
    label: 'Плановое время сдачи ТС',
    type: 'datetime',
    additionalValidateFn: function (val) {
      return this.request.serviceEndTimeRequired ? this.request.serviceEndTimeRequired >= this.request.serviceTimeRequired : true
    },
    getAdditionalValidateMessage: function () {
      return `«${this.label}» не может быть меньше, чем «${this.requestProperties.serviceTimeRequired.label}»`
    }
  }),
  serviceDurationRequired: () => ({ label: 'Плановая продолжительность использования (часы)', type: 'number' }),
  serviceEndRequiredByDuration: () => ({ label: 'Плановый интервал использования ограничен длительностью', type: 'boolean' }),
  serviceTimeAgreed: () => ({
    label: 'Согласованное время подачи ТС',
    type: 'datetime',
    customRequiredFn: function () {
      if (this.requestProperties.serviceTimeAgreed.serverRequiredFn && this.requestProperties.serviceTimeAgreed.serverRequiredFn()) {
        return !this.request.serviceTimeRequired || this.request.serviceTimeRequired < Date.now()
      } else {
        return false
      }
    }
    // dateTimeValidateFn
  }),
  driver: () => ({ label: 'Водитель', type: 'object' }),
  address: () => ({ label: 'Адрес подачи', type: 'address' }),
  organization: () => ({ label: 'Организация', type: 'object' }),
  vehicleType: () => ({
    label: 'Тип требуемого ТС',
    type: 'object',
    customRequiredFn: function () {
      if (this.requestProperties.vehicleType.serverRequiredFn && this.requestProperties.vehicleType.serverRequiredFn()) {
        return !this.request.vehicleGroupProvision
      }
      return false
    }
  }),
  vehicleGroupType: () => ({
    label: 'Тип требуемой группы ТС',
    type: 'object',
    customRequiredFn: function () {
      if (this.requestProperties.vehicleGroupType.serverRequiredFn && this.requestProperties.vehicleGroupType.serverRequiredFn()) {
        return !!this.request.vehicleGroupProvision
      }
      return false
    }
  }),
  vehicleGroupProvision: () => ({ label: 'Требуется группа ТС', type: 'boolean' }), // Предоставление группы ТС
  orderNumber: () => ({ label: 'Номер заказа', type: 'string' }),
  crewSize: () => ({ label: 'Численность экипажа', type: 'integer' }),
  providableToBrigade: () => ({ label: 'ТС предоставляется бригаде', type: 'boolean' }),
  workAreas: () => ({ label: 'Направления работ', type: 'objects' }),
  applicantWorkAreas: () => ({ label: 'Фактическое направление работ', type: 'objects' }),
  plannedProject: () => ({ label: 'Проект (плановый)', type: 'object' }),
  serviceType: () => ({ label: 'Тип услуги', type: 'object' }),
  maxServiceDuration: () => ({ label: 'Продолжительность предоставления услуги (часы)', type: 'number' }),
  vehicle: () => ({ label: 'Предоставляемое ТС', type: 'object' }),
  vehicleNote: () => ({ label: 'Дополнительные сведения о ТС', type: 'text' }),
  allowedToClose: () => ({ label: 'Бригаде разрешено закрытие заявки', type: 'boolean' }),
  vehicleTransferAllowedToBrigade: () => ({ label: 'Бригаде разрешена передача ТС', type: 'boolean' }),
  brigadeAssignmentAllowedToBrigade: () => ({ label: 'Бригаде разрешено назначение других бригад', type: 'boolean' }),
  managementAllowedToOwner: () => ({ label: 'Управление доступно только диспетчеру-координатору', type: 'boolean' }),
  managementAllowedToAllParticipants: () => ({ label: ' Управление доступно диспетчерам всех направлений, включенных в заявку', type: 'boolean' }),
  brigades: () => ({ label: 'Бригады для назначения', type: 'table', subType: 'brigades' }),
  comments: () => ({ label: 'Комментарии', type: 'table' }),
  routePoints: () => ({
    label: 'Маршрутный лист',
    type: 'table',
    recordProperties: {
      // только несовпадающие с typeof
      sourcedAddress: { label: 'Адрес', type: 'address' },
      projects: { label: 'Проект', type: 'objects' }
    }
  }),

  vehicleOdometerValueGroup: () => ({ blank: true }),
  startVehicleOdometerValue: () => ({
    label: 'Начальные показания одометра',
    type: 'number',
    customRequiredFn: function () {
      return !this.request.vehicleOdometerFaulty && this.requestProperties.vehicleOdometerValueGroup.requiredFn && this.requestProperties.vehicleOdometerValueGroup.requiredFn()
    }
  }),
  endVehicleOdometerValue: () => ({
    label: 'Конечные  показания одометра',
    type: 'number',
    additionalValidateFn: function (val) {
      return this.request.endVehicleOdometerValue && this.request.startVehicleOdometerValue ? this.request.endVehicleOdometerValue >= this.request.startVehicleOdometerValue : true
    },
    getAdditionalValidateMessage: function () {
      return `«${this.label}» не могут быть меньше, чем «${this.requestProperties.startVehicleOdometerValue.label}»`
    },
    customRequiredFn: function () {
      return !this.request.vehicleOdometerFaulty && this.requestProperties.vehicleOdometerValueGroup.requiredFn && this.requestProperties.vehicleOdometerValueGroup.requiredFn()
    }
  }),
  vehicleOdometerDistance: () => ({
    label: 'Пробег',
    type: 'number',
    customRequiredFn: function () {
      return !!this.request.vehicleOdometerFaulty && this.requestProperties.vehicleOdometerValueGroup.requiredFn && this.requestProperties.vehicleOdometerValueGroup.requiredFn()
    }
  }),
  vehicleOdometerFaulty: () => ({ label: 'Одометр неисправен', type: 'boolean' }),
  serviceDuration: () => ({ label: 'Продолжительность использования ТС', type: 'number' }),
  startServiceTime: () => ({ label: 'Дата/время первой подачи ТС', type: 'datetime' }),
  endServiceTime: () => ({
    label: 'Дата/время отбытия ТС',
    type: 'datetime',
    additionalValidateFn: function (val) {
      return this.request.endServiceTime && this.request.startServiceTime ? this.request.endServiceTime >= this.request.startServiceTime : true
    },
    getAdditionalValidateMessage: function () {
      return `«${this.label}» не может быть меньше, чем «${this.requestProperties.startServiceTime.label}»`
    }
  }),

  costDetailsServiceDuration: () => ({ label: 'Время / Продолжительность использования ТС (часы)', type: 'number' }),
  costDetailsDistance: () => ({ label: 'Пробег', type: 'number' }),
  costDetailsProject: () => ({ label: 'Проект (отчётный)', type: 'object' }),

  replacementRequest: () => ({
    label: 'Заявка на замену',
    type: 'object'
    // subType: 'vehicleProvision'
  }),
  replacingRequest: () => ({
    label: 'Заменённая заявка',
    type: 'object'
    // subType: 'vehicleProvision'
  }),

  readyDocument: () => ({
    label: 'Заменённая заявка',
    type: 'documents'
  })
}
